export default __webpack_public_path__ + "static/index_reason_software-dc65e48d3b6277e4f8f3e63ebf1672ee.png";